import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import PetCrateList from "../../components/PetCrateList/PetCrateList";
import AddPetCrate from "../../components/AddPetCrate/AddPetCrate";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Wrapper from "../../components/UI/Wrapper";
import PetCrate from "../../components/PetCrate/PetCrate";
import PaginationLink from "../../components/Pagination/Pagination";

function PetCrateMaster() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [selectedPetCrateID, setSelectedPetCrateID] = useState();
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState();
  const [selectedTseedID, setSelectedTseedID] = useState("");
  const [selectedCrate_ID, SetSelectedCrate_ID] = useState();
  const [crateSelObj, setCrateSelObj] = useState({});
  const [filterCityData, setFilterCityData] = useState(false);

  const title = "Add Pet Crate";
  const heading = "Pet Crate List";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      
      axios
        .get(`${baseAPI}adminget/GetAllPetCrates?Crate_ID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          // console.log("", response.data.data);          
          setUserDetailResponse(response.data.data);          
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
    if (openAddProfile) {
      setOpenProfile(false);
    } else if (openProfile) {
      setOpenAddProfile(false);
    }
  }

  useEffect(() => {
    tokenStorage();
  },[]);

  const GetId = (obj) => {
    // setSelectedPetCrateID(param);
    setCrateSelObj(obj);
  };



  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Pet Crate Master | <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Pet Crate </span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <div>
            <Wrapper className="ViewLeadDetails">
              <MasterTopButtons
                title={title}
                heading={heading}
                setOpenAddProfile={setOpenAddProfile}
                openAddProfile={openAddProfile}
                setOpenProfile={setOpenProfile}
                setFilterCityData = {setFilterCityData}
                  filterCityData = {filterCityData}
              />
              {openAddProfile ? (
                <AddPetCrate
                  tokenStorage={tokenStorage}
                  openAddProfile={openAddProfile}
                  setOpenAddProfile={setOpenAddProfile}
                  successMessage={successMessage}
                  setSuccessMessage={setSuccessMessage}
                  userDetailResponse={userDetailResponse}
                />
              ) : null}
              {openProfile ? (
                <PetCrate
                  tokenStorage={tokenStorage}
                  openProfile={openProfile}
                  setOpenProfile={setOpenProfile}
                  setSelectedPetCrateID={setSelectedPetCrateID}
                  crateSelObj={crateSelObj}
                />
              ) : null}
              <PetCrateList
              userDetailResponse={userDetailResponse}
                setOpenProfile={setOpenProfile}
                openProfile={openProfile}
                GetId={(param) => GetId(param)}
                openAddProfile={openAddProfile}
                setOpenAddProfile={setOpenAddProfile}
              />
              <PaginationLink />
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PetCrateMaster;
